import { configureStore } from '@reduxjs/toolkit';

import activeChatItem from './activeChatItemSlice';
import chatHistory from './chatHistorySlice';
import userData from './userDataSlice';

const ChatbotStore = configureStore({
  reducer: { userData, chatHistory, activeChatItem },
});

export type ChatbotState = ReturnType<typeof ChatbotStore.getState>;
export default ChatbotStore;
